import { Injectable } from '@angular/core';
import { Application } from 'app/applications/application.model';
import { ApplicationsService } from 'app/applications/applications.service';
import { WebApi } from 'app/core/web-api.service';
import { concat, Observable } from 'rxjs';
import { tap, toArray } from 'rxjs/operators';
import { ServiceType } from '../core/service-type.model';
import { UserSettingsService } from './user-settings.service';

interface AccountResponse {
    id: string;
    company: string;
    country: string;
    created: string;
    resellerId: string;
    customizableMachineTranslation: boolean;
    allowInvoiceCapture: boolean;
    allowDataCapture: boolean;
}

interface AccountPaymentInfoResponse {
    currency: string;
    type: string;
}

export class Account {

    allowDataCapture: boolean;
    allowInvoiceCapture: boolean;
    currency: string;
    id: string;
    paymentType: string;

    constructor(account: AccountResponse, paymentInfo: AccountPaymentInfoResponse, applications: Application[]) {
        // see: https://tfs/Cloud/FlexiCapture/_workitems/edit/6183
        this.allowDataCapture = true;
        this.allowInvoiceCapture = true;
        this.currency = paymentInfo.currency;
        this.id = account.id;
        this.paymentType = paymentInfo.type;
    }
}

@Injectable()
export class AccountService {

    account: Account;

    constructor(
        private _applicationsService: ApplicationsService,
        private _userSettingsService: UserSettingsService,
        private _webApi: WebApi) {
    }

    init(): Observable<[AccountResponse, AccountPaymentInfoResponse, Application[]]> {
        return concat(
            this._webApi.getOnce('/v1/account'),
            this._webApi.getOnce('/v1/account/paymentInfo'),
            this._applicationsService.init(),
        )
            .pipe(
                toArray(),
                tap(([account, paymentInfo, applications]: [AccountResponse, AccountPaymentInfoResponse, Application[]]) => {
                    this.account = new Account(account, paymentInfo, applications);
                    if (!this.account.allowInvoiceCapture) {
                        this._userSettingsService.serviceType = ServiceType.DocumentCapture;
                    }
                }),
            );
    }

    isTrialAccount(): boolean {
        return (this.account.paymentType === 'Trial');
    }
}
